import menu from "../utils/menu.js";

export default class MenuComponent {
    constructor() {
        menu().bindEvents();
    }

    init() {
        menu().setActiveItem();
    }
};
